module.exports = __webpack_public_path__ + "static/media/work-10.d91e9749.jpg";